// extracted by mini-css-extract-plugin
export var cardHeader = "_jl-1";
export var contentCard = "_jl-0";
export var headerActions = "_jl-3";
export var reorderHandle = "_jl-5";
export var titleArea = "_jl-2";
export var titleAreaWithHandle = "_jl-4";